export default function (error, vueCompoment, prefix) {
  if (error.response != null) {
    vueCompoment.$message.error((prefix != null ? prefix : 'Ошибка при попытке обратиться к серверу:') + ' ' + error.response.status + ', ' + (error.response.data.error != null ? error.response.data.error : error.response.data.message))
  } else {
    console.log(error)
    vueCompoment.$message.error((prefix != null ? prefix : 'Ошибка при попытке обратиться к серверу:') + ' Не доступен')
  }
}



// WEBPACK FOOTER //
// ./src/technical/serverErrorHandling.js